//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
export default {
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      mapHasHover: true,
      mapHasSelected: false,
      coordinate: [116.177427669, 28.861500052],
    };
  },
  props: {
    landList: {
      type: Array,
    },
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    if (this.landList && this.landList.length > 0) {
      let lng, lat;
      let temp = JSON.parse(this.landList[0].centroid).coordinates;
      lng = temp[0];
      lat = temp[1];
      let Coordinate = {
        x: lng,
        y: lat,
      };
      this.coordinate = Coordinate;
      this.TalksMapDialog.land(
        this.landList,
        "croplandEdge",
        "",
        this.mapHasHover,
        this.mapHasSelected
      );
    }
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
  },
};
